import {createContext, useReducer} from 'react'

export const CurrentTripContext = createContext()

export const currentTripReducer = (state, action) => {  //state is a reliable previous state value, action is the object we passed into the dispatch function (type and payload)
    switch (action.type) {
        //trip
        case 'SET_TRIP':  //can also be used to update
            return {
                ...state,
                trip: action.payload
            }
        //flights
        case 'SET_FLIGHTS':  //can also be used to update
            return {
                ...state,
                flights: action.payload
            }
        case 'CREATE_FLIGHT':  //sorts flights after a flight is added 
            const updatedFlights = [action.payload, ...state.flights]

            updatedFlights.sort((a, b) => {
                if (a.departure_date < b.departure_date) return -1
                if (a.departure_date > b.departure_date) return 1
                if (a.departure_time < b.departure_time) return -1
                if (a.departure_time > b.departure_time) return 1

                return 0
            });
            return {
                ...state,
                flights: updatedFlights
            }
        case 'UPDATE_FLIGHT':
            const updateFlights = state.flights.map((f) => 
                f._id === action.payload._id ? action.payload : f
            )
            updateFlights.sort((a, b) => {
                if (a.departure_date < b.departure_date) return -1
                if (a.departure_date > b.departure_date) return 1
                if (a.departure_time < b.departure_time) return -1
                if (a.departure_time > b.departure_time) return 1

                return 0
            })
            return {
                ...state,
                flights: updateFlights
            }
        case 'DELETE_FLIGHT':
            return {
                ...state,
                flights: state.flights.filter((f) => f._id !== action.payload._id)  
            }
        //activities
        case 'SET_ACTIVITIES':  //can also be used to update
            return {
                ...state,
                activities: action.payload
            }
        case 'CREATE_ACTIVITY':
            const updatedActivities = [action.payload, ...state.activities]
            updatedActivities.sort((a, b) => {
                if (a.activity_date < b.activity_date) return -1
                if (a.activity_date > b.activity_date) return 1
                if (a.start_time < b.start_time) return -1
                if (a.start_time > b.start_time) return 1

                return 0
            })
            return {
                ...state,
                activities: updatedActivities
            }
        case 'UPDATE_ACTIVITY':
            const updateActivities = state.activities.map((a) =>
                a._id === action.payload._id ? action.payload : a
            )
            updateActivities.sort((a, b) => {
                if (a.activity_date < b.activity_date) return -1
                if (a.activity_date > b.activity_date) return 1
                if (a.start_time < b.start_time) return -1
                if (a.start_time > b.start_time) return 1

                return 0
            })
            return {
                ...state,
                activities: updateActivities
            }
        case 'DELETE_ACTIVITY':
            return {
                ...state,
                activities: state.activities.filter((a) => a._id !== action.payload._id)  
            }
        //accomodations
        case 'SET_ACCOMODATIONS':
            return {
                ...state,
                accomodations: action.payload
            }
        case 'CREATE_ACCOMODATION':
            const updatedAccomodations = [action.payload, ...state.accomodations]
            updatedAccomodations.sort((a, b) => {
                if (a.checkin_date < b.checkin_date) return -1
                if (a.checkin_date > b.checkin_date) return 1
                const timeA = a.checkin_time || "23:59"
                const timeB = b.checkin_time || "23:59"
                if (timeA < timeB) return -1
                if (timeA > timeB) return 1

                return 0
            })
            return {
                ...state,
                accomodations: updatedAccomodations
            }
        case 'UPDATE_ACCOMODATION':
            const updateAccomodation = state.accomodations.map((a) => 
                a._id === action.payload._id ? action.payload : a
            )
            updateAccomodation.sort((a, b) => {
                if (a.checkin_date < b.checkin_date) return -1
                if (a.checkin_date > b.checkin_date) return 1
                const timeA = a.checkin_time || "23:59"
                const timeB = b.checkin_time || "23:59"
                if (timeA < timeB) return -1
                if (timeA > timeB) return 1

                return 0
            })
            return {
                ...state,
                accomodations: updateAccomodation
            }
        case 'DELETE_ACCOMODATION':
            return {
                ...state,
                accomodations: state.accomodations.filter((a) => a._id !== action.payload._id)
            }
        default:
            return state
    }
}

export const CurrentTripContextProvider = ({ children }) => {  //children represents the app component that we wrapped in the index.js file in this case
    const [state, dispatch] = useReducer(currentTripReducer, { //useReducer similar to use state, with a state value and a dispatch to update the state value. (in this case, initial value is the workouts object.)
        //whats different is the workoutsReducer function. if we want to update state object, we call a dispatch function. inside the dispatch funcion, we pass an object as an argument which has a type property, which describes in words the state changes we are making. 
        //the payload represents any data we need to make this change, eg an array of workout objects. 
        trip: null,
        flights: [],
        activities: [],
        accomodations: []
    })

    
    
    return ( //...state is essentially state.workouts, just spreading whats in state. 
        <CurrentTripContext.Provider value={{...state, dispatch}}>
            { children }
        </CurrentTripContext.Provider>
    )
}